import React from 'react';
import { Music2, CheckCircle2, Youtube } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { ceremonyMoments } from '../data/mock';

const Musicas = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#DFD6CD]/20">
      {/* Header */}
      <section className="pt-32 pb-16 px-4 bg-gradient-to-br from-[#DFD6CD] to-white">
        <div className="container mx-auto text-center">
          <div className="inline-block mb-6">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-sm rounded-full text-sm font-medium text-[#920216] border border-[#CDAD1E]/30">
              <Music2 size={16} className="text-[#B30310]" />
              Guia Completo
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#920216] mb-6">
            Músicas para sua Cerimônia Católica
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Escolhemos cuidadosamente as músicas mais apropriadas para cada momento da sua cerimônia,
            respeitando a liturgia católica e garantindo uma celebração emocionante e reverente.
          </p>
        </div>
      </section>

      {/* Moments Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="mb-12 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-[#920216] mb-4">
              Sugestões por Momento da Cerimônia
            </h2>
            <p className="text-gray-600">
              Clique em cada momento para ver nossas sugestões de músicas
            </p>
          </div>

          <Accordion
            type="multiple"
            className="space-y-4"
          >
            {ceremonyMoments.map((moment) => (
              <AccordionItem
                key={moment.id}
                value={`item-${moment.id}`}
                className="border-[#CDAD1E]/30 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow overflow-hidden"
              >
                <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-[#DFD6CD]/20 transition-colors">
                  <div className="flex items-center gap-4 text-left">
                    <div className="w-10 h-10 bg-[#DFD6CD] rounded-full flex items-center justify-center flex-shrink-0">
                      <Music2 className="text-[#B30310]" size={20} />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-[#920216]">{moment.moment}</h3>
                      <p className="text-sm text-gray-600">{moment.description}</p>
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
                    {moment.songs.map((song, index) => (
                      <Card key={index} className="border-[#CDAD1E]/20 hover:border-[#CDAD1E] transition-colors">
                        <CardContent className="p-4">
                          <div className="flex items-start justify-between gap-4">
                            <div className="flex-1">
                              <div className="flex items-center gap-2 mb-2">
                                <h4 className="font-semibold text-[#920216]">{song.title}</h4>
                              </div>
                              <p className="text-sm text-gray-600 mb-2">{song.artist}</p>
                              <p className="text-sm text-gray-700 italic">{song.note}</p>
                              {song.youtube && (
                                <a
                                  href={song.youtube}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="inline-flex items-center gap-1 mt-2 text-sm text-red-600 hover:text-red-700 transition-colors"
                                >
                                  <Youtube size={16} />
                                  Ouvir no YouTube
                                </a>
                              )}
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Info Box */}
          <Card className="mt-12 bg-[#DFD6CD]/30 border-[#CDAD1E]/30">
            <CardContent className="p-6">
              <h3 className="text-lg font-semibold text-[#920216] mb-3 flex items-center gap-2">
                <CheckCircle2 className="text-[#B30310]" size={20} />
                Sobre as Músicas Litúrgicas
              </h3>
              <p className="text-gray-700 leading-relaxed">
                As músicas marcadas como "Litúrgicas" são apropriadas segundo as normas da Igreja Católica
                para uso em cerimônias sacramentais. Nossa equipe tem amplo conhecimento da liturgia e pode
                auxiliá-los na escolha das músicas mais adequadas para cada momento da sua cerimônia.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Musicas;